<template lang='pug'>
  div
    v-row(no-gutters align='center' justify='center' v-if='!gitHistory || !gitHistory.length').pa-4
      .text-h5.grey--text No History Yet
    div(v-if='gitHistory && gitHistory.length')
      .text-subtitle-1.grey--text.pl-6 History
      div(v-for='(item, index) of gitHistory' :key='item.sha' v-if='!index || showHistory')
        v-row(no-gutters).pl-6
          v-col(cols='12').text-body-1.pt-1.pb-1.pl-4.pr-4
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Sha:
              v-col
                a(:href='item.html_url' target='_blank') {{item.sha}}
                | &nbsp;-&nbsp;
                a(@click='emitRevertContent(item)') (Revert)
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Author:
              v-col {{item.commit.author.name}} <{{item.commit.author.email}}>
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Committed:
              v-col
                v-tooltip(right)
                  template(v-slot:activator='{on}')
                    span(v-on='on') {{item.commit.author.date | date}}
                  span {{item.commit.author.date | timeago}}
            v-row(no-gutters)
              v-col.text-body-2(cols='4' sm='3') Message:
              v-col {{item.commit.message}}
        v-divider
      v-row(no-gutters align='center' justify='center' v-if='hasMoreHistory')
        v-tooltip(bottom)
          template(v-slot:activator='{on}')
            v-btn(text icon @click='showHistory = !showHistory' v-on='on')
              v-icon(v-if='!showHistory') keyboard_arrow_down
              v-icon(v-if='showHistory') keyboard_arrow_up
          div
            | Show&nbsp;
            span(v-if='!showHistory') More
            span(v-if='showHistory') Less
</template>

<script>
import GitHub from '../api/github';

export default {
  name: 'BionicMetricsGitHistory',
  props: {
    type: {
      type: String,
      validator: (val) => ['test', 'module'].includes(val)
    },
    gitName: {
      type: String,
      required: true
    }
  },
  asyncComputed: {
    gitHistory() {
      if (!this.gitName || !this.type) return [];
      return GitHub.history(this.type, this.gitName);
    }
  },
  computed: {
    hasMoreHistory() {
      return this.gitHistory && this.gitHistory.length > 1;
    }
  },
  methods: {
    update() {
      this.$asyncComputed.gitHistory.update();
    }
  },
  data() {
    return {
      showHistory: false
    };
  }
};
</script>

<style scoped>
</style>
